import { render, staticRenderFns } from "./JcSet.vue?vue&type=template&id=6445769b&scoped=true&"
import script from "./JcSet.vue?vue&type=script&lang=js&"
export * from "./JcSet.vue?vue&type=script&lang=js&"
import style0 from "./JcSet.vue?vue&type=style&index=0&id=6445769b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6445769b",
  null
  
)

export default component.exports